export default __webpack_public_path__ + "static/media/animation-key2.51a5c548.gif";